export interface FetchImplantTypesQueryParams {
  procedure_id: number | null,
  quantity: number | null
}